"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _lodash = _interopRequireDefault(require("lodash"));
var _vuex = require("vuex");
var _recommended = require("@/api/recommended");
var _iconManage = _interopRequireDefault(require("./components/icon-manage"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    IconManage: _iconManage.default
  },
  data: function data() {
    return {
      tableData: [],
      totalPage: 1,
      currentPage: 1,
      perPage: 15,
      loading: true,
      manageType: '',
      chooseData: {},
      searchProductId: '' // 搜索产品ID
    };
  },
  computed: (0, _vuex.mapState)({
    all_products: function all_products(state) {
      var products = _lodash.default.cloneDeep(state.common.all_products);
      var item = {
        id: 'all',
        name: '全部测算'
      };
      if (products) {
        // 过滤无 app_id 的测算
        products = products.filter(function (item) {
          return !!item.app_id;
        });
        products.unshift(item);
      }
      return products;
    }
  }),
  mounted: function mounted() {
    this.getList();
    if (!this.all_products) {
      this.getAllProducts();
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)({
    getAllProducts: 'common/getAllProducts'
  })), {}, {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      var params = {
        product_id: this.searchProductId,
        page: this.currentPage,
        per_page: this.perPage
      };
      (0, _recommended.getProductIconList)(params).then(function (_ref) {
        var code = _ref.code,
          data = _ref.data;
        _this.loading = false;
        if (code === 200) {
          _this.tableData = data === null || data === void 0 ? void 0 : data.data;
          _this.totalPage = data === null || data === void 0 ? void 0 : data.last_page;
        }
      }).catch(function () {
        _this.loading = false;
      });
    },
    onSearch: function onSearch() {
      this.getList();
    },
    onAdd: function onAdd() {
      this.$refs.managePop.dialogVisible = true;
      this.manageType = 'add';
      this.chooseData = {};
    },
    onModify: function onModify(val) {
      this.$refs.managePop.dialogVisible = true;
      this.manageType = 'edit';
      this.chooseData = _lodash.default.cloneDeep(val);
    },
    // 分页
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loading = true;
      this.getList();
    }
  })
};